export default __webpack_public_path__ + "beta-maps-example-point-annotation-1200-5f00214644da80ef64c9582fc50af8a1.webp";